import {CursorBasedPaginationResponse, QueryBaseTypeWithCursorPaginationWhereAndOrder} from 'api/common';
import {LoginResponesModel} from 'models/auth/login.model';

export interface ActivityModel {
    active: boolean;
    activityDate: Date | string;
    activityType: ActivityType;
    data: string;
    description?: string;
    id: string;
    status: string;
    objectId?: string;
    objectType?: string;
    user: string;
    userId?: string;
}

export enum ActivityType {
    Call = 'CALL',
    Comment = 'COMMENT',
    Email = 'EMAIL',
    None = 'NONE',
    Sms = 'SMS',
}
export interface CommentUserInfo {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    avatarUrl?: string;
}
export interface ActivitiesByObjectIdAndObjectTypePaginationResponse {
    activitiesByObjectIdAndObjectType: CursorBasedPaginationResponse<ActivityModel>;
}

export interface ActivtyGetAllbyObjectIdRequest extends QueryBaseTypeWithCursorPaginationWhereAndOrder<ActivityModel> {
    objectId: string;
    objectType: string;
}

export interface ActivityInputRequest {
    activityDate: Date | string;
    activityType: ActivityType;
    data: string;
    status: string;
    description?: string;
    user: string;
    userId?: string;
}

export interface ActivityResponse extends Omit<ActivityModel, 'user'> {
    user: LoginResponesModel;
}

export interface ActivityUpdateModelInput extends ActivityInputRequest {
    id: string;
    objectId?: string;
    objectType?: string;
}

export interface CreateActivityRequest {
    input: ActivityInputRequest;
    objectId: string;
    objectType: string;
}

export interface CommentStatusMapper {
    Active: boolean;
    Deleted: {status: boolean; timestamp?: string};
    Updated: {value: string; timestamp: string}[];
}
